import { Pipe, PipeTransform } from '@angular/core';
import { humanize } from './types';

@Pipe({
  name: 'humanize',
  standalone: true
})
export class HumanizePipe implements PipeTransform {
  transform(str: string|undefined): string|undefined {
    return humanize(str??'') ?? str;
  }

}
